"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFragmentWhere = exports.useFragment = void 0;
var useFragment_1 = require("./useFragment");
Object.defineProperty(exports, "useFragment", { enumerable: true, get: function () { return __importDefault(useFragment_1).default; } });
var useFragmentWhere_1 = require("./useFragmentWhere");
Object.defineProperty(exports, "useFragmentWhere", { enumerable: true, get: function () { return __importDefault(useFragmentWhere_1).default; } });
//# sourceMappingURL=index.js.map